import React from 'react';
import { ScrollView, Stack, useTheme, SizableText } from 'tamagui';
import loadable from '@loadable/component';
import Breadcrumb from 'components/utility/Breadcrumb';
import { RecentArticles } from 'components/cards/Articles';
import Loading from 'components/utility/Loading';

const Filters = loadable(() => import('components/utility/Filters'), {
  fallback: <Loading />,
});

interface Taxon {
  id: string;
}

interface ArticleData {
  category: string;
  url: string;
}

interface Article {
  taxon: Taxon;
  data: ArticleData;
}

interface MainArticleProps {
  initialArticlesData?: Article[];
  [key: string]: any;
}

const MainArticle = ({
  initialArticlesData,
  ...props
}: MainArticleProps): JSX.Element => {
  const theme = useTheme();

  return (
    <ScrollView
      minHeight={600}
      contentContainerStyle={{ justifyContent: 'flex-start' }}
      zIndex={10}
      bg={theme.background}
    >
      <Stack
        py={15}
        $md={{
          py: 50,
        }}
      />
      <Breadcrumb />
      <Filters hideCalendar={true} />
      {initialArticlesData?.map((article, index) => (
        <RecentArticles
          key={index}
          taxonId={article.taxon.id}
          title={article.data.category}
          url={article.data.url}
          hideCalendar={false}
          mainPage
          initialData={article.data}
          {...props}
        />
      ))}
      <Stack height={50} />
    </ScrollView>
  );
};

export default MainArticle;
